/* import __COLOCATED_TEMPLATE__ from './content.hbs'; */
import Component from '@ember/component';
import { SCROLLABLE_SELECTOR } from '@square/ember-prism/components/prism-modal';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { bind } from '@ember/runloop';
const KEYCODE_TAB = 9;
const focusableElementsSelector = 'a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), *[tabindex], *[contenteditable]';
export default Component.extend({
  classNames: ['prism-modal-container__content'],
  contentElement: null,
  focusableElements: null,
  didInsertElement() {
    this.set('contentElement', document.querySelector(SCROLLABLE_SELECTOR));
    disableBodyScroll(this.contentElement);
    this._setFocusableElements();
    this._boundFunction = bind(this, this._trapTabKey);
    document.addEventListener('keydown', this._boundFunction);
  },
  // Account for adding or removing focusable elements
  didUpdate() {
    this._setFocusableElements();
  },
  willDestroyElement() {
    enableBodyScroll(document.querySelector(SCROLLABLE_SELECTOR));
    document.removeEventListener('keydown', this._boundFunction);
  },
  _setFocusableElements() {
    const focusableElements = this.contentElement.querySelectorAll(focusableElementsSelector);
    this.set('focusableElements', [...focusableElements]);
  },
  // If the user is accessing the modal via a keyboard, trap tabbing inside of the modal.
  // https://github.com/gdkraus/accessible-modal-dialog/blob/master/modal-window.js
  _trapTabKey(event) {
    if (event.keyCode === KEYCODE_TAB) {
      const focusedItem = document.activeElement;
      const focusedItemIndex = this.focusableElements.indexOf(focusedItem);
      if (this.focusableElements.length === 0) {
        event.preventDefault();
        return;
      }

      // If focused on first item and user presses back tab, go to the last focusable item
      if (event.shiftKey && focusedItemIndex === 0) {
        this.focusableElements[this.focusableElements.length - 1].focus();
        event.preventDefault();
      } else if (!event.shiftKey && (focusedItemIndex === this.focusableElements.length - 1 || focusedItemIndex === -1)) {
        // If focused on the last item and user presses tab, go to the first focusable item
        this.focusableElements[0].focus();
        event.preventDefault();
      }
    }
  }
});